import { Component, Injector, Input } from '@angular/core';

import { MessageService } from 'primeng/api';

import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { HubspotFormService } from '../../../../Common/Misc/services/hubspot-form.service';

@Component({
    selector: 'agpr-content-library-popup',
    templateUrl: './content-library-popup.component.html',
    styleUrls: ['./content-library-popup.component.scss'],
    standalone: false
})
export class ContentLibraryPopupComponent extends AbstractDialogComponent {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() positionY: number = 0;
    @Input() positionX: number = 0;
    @Input() containerWidth: number = 0;

    selfClick: boolean = false;
    loading: boolean = false;

    constructor(
        public coreDialogService: CoreDialogService,
        public configService: ConfigService,
        public messageService: MessageService,
        public localizationService: LocalizationService,
        public injector: Injector,
        protected hubspotFormService: HubspotFormService,
    ) {
        super(coreDialogService, 'ContentLibraryPopup');
    }

    cancel(): void {
        event.stopPropagation();
        this.coreDialogService.close('ContentLibraryPopup');
    }

    openContactUrl() {
        window.open('https://www.agilitypr.com/contact/', '_blank');
    }

}
